/* CB wallet badge (KYS, 2026-10-04). Markup + pre-paint resolver: snippets/cb-wallet.liquid.
   Public: window.cbWallet.set(code) / .clear() / .open() / .close() / .state()
           document 'cbw:update' CustomEvent {detail:{code}} -> set(code)
   Emits:  'cbw:change' {detail:{state, code}} on document after every render. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cbw]');
  if (!root || root.__cbw) return;
  root.__cbw = true;

  var LS = 'cbw';
  var LABELS = { 'CREDIT-COMPTE': "Crédit d'achat", 'CREDIT-BIENVENUE': "Crédit d'achat de bienvenue", 'CREDIT-V2-A': "Crédit d'achat", 'CREDIT-V2-B': "Crédit d'achat" };
  var W2 = window.cbwW2 || {}; /* wave 2: per-code amount + end (snippets/cb-wallet.liquid) */
  var NB = '\u00a0';
  var ARIA = { offer: 'Débloquez 10,28\u00a0€ de crédit', credit: 'Mon crédit : 10,28\u00a0€', none: 'Mon crédit : 0,00 €' };
  var MSG_APPLIED = 'Appliqué automatiquement à votre panier, rien à saisir.';
  var MSG_JUST = "10,28\u00a0€ de crédit d'achat ajoutés. Ils se déduisent automatiquement de votre première commande.";
  var btn = root.querySelector('[data-cbw-toggle]');
  var panel = root.querySelector('.cbw-panel');
  var form = root.querySelector('#cbwForm');
  var email = root.querySelector('#cbwEmail');
  var err = root.querySelector('[data-cbw-err]');
  var submit = root.querySelector('[data-cbw-submit]');
  var label = root.querySelector('[data-cbw-label]');
  var amtB = root.querySelector('[data-cbw-amt-b]'), amtEm = root.querySelector('[data-cbw-amt]'), chipEl = root.querySelector('[data-cbw-chip]'), endEl = root.querySelector('[data-cbw-end]');
  var msg = root.querySelector('[data-cbw-msg]');
  var useLink = root.querySelector('[data-cbw-use]');
  var useHref = useLink ? useLink.getAttribute('href') : '/collections/all';
  var current = { state: root.getAttribute('data-state') || 'offer', code: root.getAttribute('data-code') || '' };
  var applying = null;

  function readLS() { try { return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; } }
  function writeLS(code, src) { try { localStorage.setItem(LS, JSON.stringify({ code: code, t: Date.now(), src: src || '' })); } catch (e) {} }
  function clearLS() { try { localStorage.removeItem(LS); } catch (e) {} }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }

  /* Apply a code to the session + cart. /discount/<CODE> sets the discount_code cookie and attaches it to the cart. */
  function apply(code) {
    if (!LABELS[code]) return Promise.resolve(null);
    if (applying && applying.code === code) return applying.p;
    var p = fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (cart) { applying = null; emit('ky:cart:refresh'); return cart; });
    applying = { code: code, p: p };
    return p;
  }

  /* Amount + end shown for the held code: wave 1 / bienvenue = 10,28 € and no end date; wave 2 = per-code amount and end date. */
  function amountFor(code) { var w = W2[code]; return w ? { amt: w.amt, chip: w.chip, end: w.endTxt || '' } : { amt: '10,28', chip: '10,28', end: '' }; }
  function paintAmount(code) {
    var a = amountFor(code);
    if (amtB) amtB.textContent = a.amt + NB + '€';
    if (amtEm) amtEm.textContent = a.amt + NB + '€';
    if (chipEl) chipEl.textContent = a.chip + NB + '€';
    if (endEl) { endEl.textContent = a.end ? "Jusqu'au " + a.end : ''; endEl.hidden = !a.end; }
    return a;
  }

  function render(next, flip) {
    current = next;
    root.setAttribute('data-state', next.state);
    if (next.code) root.setAttribute('data-code', next.code); else root.removeAttribute('data-code');
    var amt = paintAmount(next.state === 'credit' ? next.code : '');
    btn.setAttribute('aria-label', next.state === 'credit' ? 'Mon crédit : ' + amt.amt + '\u00a0€' : (ARIA[next.state] || ARIA.offer));
    if (label) label.textContent = LABELS[next.code] || 'Mon crédit';
    if (msg) msg.textContent = next.just ? MSG_JUST : MSG_APPLIED;
    if (useLink) useLink.setAttribute('href', next.code ? '/discount/' + encodeURIComponent(next.code) + '?redirect=' + encodeURIComponent(useHref) : useHref);
    if (flip) {
      root.classList.remove('cbw--flip'); void root.offsetWidth; root.classList.add('cbw--flip');
      setTimeout(function () { root.classList.remove('cbw--flip'); }, 1100);
    }
    if (!panel.hidden) arrow();
    stickSync();
    cdTick();
    emit('cbw:change', { state: next.state, code: next.code || '' });
  }

  function set(code, opts) {
    code = String(code || '').toUpperCase();
    if (!LABELS[code]) return Promise.resolve(null);
    opts = opts || {};
    writeLS(code, opts.src || 'set');
    render({ state: 'credit', code: code, just: !!opts.just }, opts.flip !== false);
    return apply(code);
  }

  function clear() { clearLS(); render(window.cbwBoot && window.cbwBoot.logged ? { state: 'none', code: '' } : { state: 'offer', code: '' }); }

  /* ---------- panel ---------- */
  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled])')).filter(function (el) {
      return el.offsetParent !== null;
    });
  }
  function isOpen() { return !panel.hidden; }
  function arrow() { try { panel.style.setProperty('--cbw-ar', Math.round(btn.offsetWidth / 2) + 'px'); } catch (e) {} }
  function open() {
    if (isOpen()) return;
    panel.hidden = false;
    arrow();
    btn.setAttribute('aria-expanded', 'true');
    stickSchedule();
    emit('ky:nav:close');
    var f = current.state === 'offer' && email ? email : focusables()[0];
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 30);
  }
  function close(restore) {
    if (!isOpen()) return;
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    stickSchedule();
    if (restore !== false) btn.focus();
  }
  btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (isOpen()) close(); else open(); });
  root.querySelector('[data-cbw-close]').addEventListener('click', function () { close(); });
  document.addEventListener('click', function (e) { if (isOpen() && !root.contains(e.target)) close(false); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('ky:cart:open', function () { close(false); });

  /* ---------- signup form ----------
     Native Shopify customer form POST (page reloads), same rail as snippets/cb-tirage-popup.liquid:
     KYS customer forms carry Shopify hCaptcha, which only injects its token on a native submit
     (a fetch() POST gets 403). sessionStorage cbw_pend marks the attempt; after the reload the
     server-rendered markers in #cbwForm ([data-cbw-posted] / [data-cbw-errors]) decide the outcome. */
  function showErr(text) {
    err.textContent = text || '';
    if (email) email.setAttribute('aria-invalid', text ? 'true' : 'false');
  }
  function success(alreadyKnown) {
    showErr('');
    set('CREDIT-BIENVENUE', { just: true, src: alreadyKnown ? 'form-known' : 'form' });
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['track', 'credit bienvenue', { origin: 'api', properties: { source: 'wallet-badge', code: 'CREDIT-BIENVENUE' } }]);
    } catch (e) {}
  }
  function errorKind(text) {
    var t = String(text || '').toLowerCase();
    if (/taken|already|déjà|existe/.test(t)) return 'known';
    if (/invalid|invalide|format/.test(t)) return 'invalid';
    return 'other';
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      var value = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(value)) {
        e.preventDefault(); e.stopImmediatePropagation();
        showErr('Entrez une adresse email valide.'); email.focus(); return;
      }
      showErr('');
      try { sessionStorage.setItem('cbw_pend', String(Date.now())); } catch (x) {}
      if (submit) { submit.setAttribute('aria-busy', 'true'); submit.textContent = 'Un instant…'; }
    }, true);
  }

  /* ---------- sticky credit badge (2026-10-10) ----------
     B2G3-style card on the right edge (markup in snippets/cb-wallet.liquid, styles in cb-wallet.css).
     Visible only in state "credit"; never on the cart page. Muted (faded, not clickable) while the wallet
     panel, the cart drawer, the tarot popup or any large fixed overlay is open, and whenever it would sit on
     the PDP add-to-cart button / sticky add-to-cart bar or the drawer checkout button. Tap = open the panel. */
  var STICK_EB = { 'CREDIT-COMPTE': "Crédit d'achat", 'CREDIT-BIENVENUE': 'Bienvenue', 'CREDIT-V2-A': "Crédit d'achat", 'CREDIT-V2-B': "Crédit d'achat" };
  var STICK_AVOID = '#mainAtc,[data-ky-pdp-sticky],.kc-co,#cbtp';
  var stickAll = [].slice.call(document.querySelectorAll('[data-cbw-stick]'));
  var stick = stickAll.shift() || null;
  stickAll.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); }); /* one badge only */
  var stickBtn = stick && stick.querySelector('[data-cbw-stick-btn]');
  var stickEb = stick && stick.querySelector('[data-cbw-stick-eb]');
  var stickOff = !stick || stick.getAttribute('data-tpl') === 'cart';
  var stickFrame = 0, stickScanAt = 0, stickBigMuted = false, stickTimer = 0, stickShown = false;
  if (stick && stick.parentNode !== document.body) document.body.appendChild(stick);

  function stickBox() {
    var w = stick.offsetWidth, h = stick.offsetHeight;
    var vw = document.documentElement.clientWidth || window.innerWidth, vh = window.innerHeight;
    var top = stick.getBoundingClientRect().top; /* transform only moves it sideways, the top is real */
    return { left: vw - w - 2, right: vw, top: top - 2, bottom: top + h + 2 };
  }
  function hit(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
  function shown(el, cs) {
    return el.offsetWidth > 0 && el.offsetHeight > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
  }
  /* B2G3 rule: any visible fixed layer at least 60 % of the viewport tall and 240 px wide that crosses the badge. */
  function bigOverlay(box) {
    var vh = window.innerHeight, all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === stick || stick.contains(el)) continue;
      if (el.id && (el.id.indexOf('PBar') > -1 || el.id.indexOf('preview-bar') > -1)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || !shown(el, cs)) continue;
      var r = el.getBoundingClientRect();
      if (r.height < vh * 0.6 || r.width < 240) continue;
      if (hit(r, box)) return true;
    }
    return false;
  }
  function stickCheck() {
    stickFrame = 0;
    if (!stick || stick.hidden) return;
    var box = stickBox(), muted = isOpen();
    if (!muted && document.querySelector('.kycart-shell.is-open')) muted = true;
    if (!muted) {
      var avoid = document.querySelectorAll(STICK_AVOID);
      for (var i = 0; i < avoid.length && !muted; i++) {
        var el = avoid[i], cs = window.getComputedStyle(el);
        if (shown(el, cs) && hit(el.getBoundingClientRect(), box)) muted = true;
      }
    }
    var now = Date.now();
    if (!muted && now - stickScanAt > 300) { stickScanAt = now; stickBigMuted = bigOverlay(box); }
    else if (!muted && stickTimer === 0) stickTimer = setTimeout(function () { stickTimer = 0; stickScanAt = 0; stickSchedule(); }, 320);
    muted = muted || stickBigMuted;
    /* layers close with transitions that fire no mutation (visibility delay): re-check while muted, as the B2G3 badge did */
    if (muted && !stickTimer) stickTimer = setTimeout(function () { stickTimer = 0; stickScanAt = 0; stickSchedule(); }, 400);
    stick.classList.toggle('is-muted', muted);
    if (stickBtn) {
      stickBtn.tabIndex = muted ? -1 : 0;
      stickBtn.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    }
  }
  function stickSchedule() { if (stick && !stickFrame) stickFrame = window.requestAnimationFrame(stickCheck); }
  function stickSync() {
    if (!stick) return;
    var want = !stickOff && current.state === 'credit' && !!LABELS[current.code];
    if (stickEb) stickEb.textContent = STICK_EB[current.code] || 'Mon crédit';
    if (stick) {
      var sa = amountFor(current.state === 'credit' ? current.code : '');
      var sm = stick.querySelector('[data-cbw-stick-main]'), sf = stick.querySelector('[data-cbw-stick-fine]');
      if (sm) sm.textContent = "Crédit d'achat de " + sa.amt.replace(',00', '') + NB + '€ disponible';
      if (sf) sf.textContent = (sa.end ? 'Valable jusqu\u2019au ' + sa.end + '. ' : '') + 'Utilisable uniquement sur vos achats, sans valeur monétaire.';
      if (stickBtn) stickBtn.setAttribute('aria-label', "Crédit d'achat de " + sa.amt.replace(',00', '') + '\u00a0€ disponible.' + (sa.end ? ' Valable jusqu\u2019au ' + sa.end + '.' : '') + ' Utilisable uniquement sur vos achats, sans valeur monétaire. Voir mon crédit');
    }
    if (!want) { stick.hidden = true; return; }
    if (stick.hidden) stick.hidden = false;
    if (!stickShown) {
      stickShown = true;
      setTimeout(function () { window.requestAnimationFrame(function () { stick.classList.add('is-in'); stickSchedule(); }); }, 700);
    }
    stickSchedule();
  }
  if (stick && !stickOff) {
    stickBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (isOpen()) close(false); else open();
    });
    window.addEventListener('scroll', stickSchedule, { passive: true });
    window.addEventListener('resize', stickSchedule, { passive: true });
    document.addEventListener('transitionend', stickSchedule, { passive: true, capture: true });
    ['ky:cart:open', 'ky:cart:close', 'ky:cart:updated'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(stickSchedule, 30); }); });
    try {
      new MutationObserver(stickSchedule).observe(document.body, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open'], subtree: true, childList: true });
    } catch (e) {}
  }

  /* ---------- countdown (2026-10-15) ----------
     Every [data-cbw-count] shows how long the held code lives (end per code in window.cbwW2, same instant as the Shopify endsAt).
     Badge + panel use the held code; the cart line carries data-cbw-code. More than 24 h: "Expire dans 3 j 14 h" (refreshed each minute).
     Last 24 h: "Expire dans 14:22:05" (ticks each second). Expired: the line hides and the wallet drops the credit state. BIENVENUE has no end: no line. */
  var cdTimer = 0;
  function cdPad(n) { return (n < 10 ? '0' : '') + n; }
  function cdFmt(ms) {
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    if (s < 86400) return 'Expire dans ' + cdPad(h) + ':' + cdPad(m) + ':' + cdPad(s % 60);
    return 'Expire dans ' + d + NB + 'j ' + h + NB + 'h';
  }
  function cdTick() {
    if (cdTimer) { clearTimeout(cdTimer); cdTimer = 0; }
    var els = document.querySelectorAll('[data-cbw-count]'), soonest = Infinity, expired = false, now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i], own = el.getAttribute('data-cbw-code'), code = own || current.code;
      var w = W2[code], end = w && w.end ? w.end : 0;
      if (!end || (!own && current.state !== 'credit')) { el.hidden = true; continue; }
      var left = end - now;
      if (left <= 0) { el.hidden = true; if (!own || code === current.code) expired = expired || current.state === 'credit'; continue; }
      var txt = cdFmt(left);
      if (el.textContent !== txt) el.textContent = txt;
      el.hidden = false;
      if (left < soonest) soonest = left;
    }
    if (expired) { clearLS(); render(window.cbwResolve ? window.cbwResolve() : { state: 'offer', code: '' }); return; }
    if (soonest === Infinity) return;
    var delay = soonest < 86400000 ? 1000 - (now % 1000) + 5 : Math.min(60000, soonest - 86400000 + 5);
    cdTimer = setTimeout(cdTick, Math.max(200, delay));
  }
  window.cbwCountRefresh = cdTick;
  ['ky:cart:updated', 'ky:cart:open'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(cdTick, 40); }); });

  /* ---------- boot ---------- */
  var r = (window.cbwResolve && window.cbwResolve()) || { state: 'offer', code: '' };
  /* native-POST fallback came back (bot challenge path): the page now carries posted_successfully */
  var pend = null; try { pend = sessionStorage.getItem('cbw_pend'); sessionStorage.removeItem('cbw_pend'); } catch (x) {}
  var postedEl = form && form.querySelector('[data-cbw-posted]');
  var errEl = form && form.querySelector('[data-cbw-errors]');
  if (pend && (postedEl || errEl)) {
    var kind = errEl ? errorKind(errEl.textContent) : 'ok';
    if (kind === 'ok' || kind === 'known') { success(kind === 'known'); }
    else {
      render(r);
      showErr(kind === 'invalid' ? 'Cette adresse email ne semble pas valide.' : 'Inscription impossible pour le moment. Réessayez dans un instant.');
    }
    open();
  } else {
    if (r.stale) clearLS();
    if (r.state === 'credit') {
      writeLS(r.code, r.cookie === r.code ? 'cookie' : 'restore');
      render({ state: 'credit', code: r.code });
      if (!r.cookie) apply(r.code); /* cookie gone (new session): silently re-apply */
    } else {
      render(r);
    }
  }

  /* Cart sync (2026-10-08, hardened 2026-10-10 incident): a held credit must be APPLIED in the cart, not just
     present. Shopify carts keep several codes; the credit codes are order discounts that do not combine with
     other order codes, so an older code left in the cart (TAROT20, FB-EMAIL-…, a typed code) wins and the
     credit sits there "applicable:false": badge 10,28 € but no credit row and no −10,28 € at checkout.
     Rule (once per cart + code set): no code -> apply the credit; credit missing or not applicable -> set the
     cart codes to the credit alone (/cart/update.js {discount}); if Shopify still refuses it, put the previous
     codes back. Reads the cart ky-cart.js already rendered ('ky:cart:updated'): no request when it is fine. */
  var cartSynced = {};
  function upCodes(cart) { return (cart.discount_codes || []).map(function (d) { return String(d.code || ''); }); }
  function creditApplied(cart, code) {
    return (cart.discount_codes || []).some(function (d) { return String(d.code || '').toUpperCase() === code && d.applicable; });
  }
  function setCartCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  document.addEventListener('ky:cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (current.state !== 'credit' || !LABELS[current.code] || !cart || !cart.item_count) return;
    if (creditApplied(cart, current.code)) return;
    var prev = upCodes(cart);
    var key = current.code + '|' + String(cart.token || '') + '|' + prev.join(',');
    if (cartSynced[key]) return;
    cartSynced[key] = true;
    if (!prev.length) { apply(current.code); return; }
    var code = current.code;
    setCartCodes(code).then(function (c) {
      if (c && !creditApplied(c, code)) return setCartCodes(prev.join(','));
    }).then(function () { emit('ky:cart:refresh'); });
  });

  document.addEventListener('cbw:update', function (e) { var c = e && e.detail && e.detail.code; if (c) set(c, { just: !!(e.detail && e.detail.just), src: (e.detail && e.detail.src) || 'event' }); });
  window.cbWallet = { set: set, clear: clear, open: open, close: close, apply: apply, state: function () { return { state: current.state, code: current.code }; } };
  emit('cbw:ready', window.cbWallet.state());
})();
